import React, { useState } from 'react';
import Form from 'react-bootstrap/Form'
import {useParams} from "react-router-dom";

import LoadingSpinner from '../components/LoadingSpinner';
import FigureCaption from '../components/FigureCaption';
import StatecountyCovidAreaspline from '../components/StatecountyCovidAreaspline'

import './CountyCovidAreaSplineTabs.css'

export default function CountyCovidAreaSplineTabs(props) {
    let county = props.county;
    let state = props.state;
    let region = props.region;

    const [cat, setCat] = useState('cases');
    const [stat, setStat] = useState('14dayrate');

    return (
        <div id="county-covid-slines">
            <Form inline={true}>
                <Form.Group>
                    <Form.Control as="select" defaultValue={cat} onChange={(e)=>{setCat(e.target.value)}}>
                          <option value="cases">Cases</option>
                          <option value="deaths">Deaths</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group>
                    <Form.Control as="select" defaultValue={stat} onChange={(e)=>{setStat(e.target.value)}}>
                        <option value="total">Total</option>
                        <option value="rate">Total as Rate</option>
                        <option value="14dayrate">14 Day Rate</option>
                        <option value="7dayrate">7 Day Rate</option>
                    </Form.Control>
                </Form.Group>
            </Form>
            {cat=='cases' && stat=='total' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"confirmed"} covidField2={"deaths"} />}
            {cat=='deaths' && stat=='total' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"deaths"} />}
            {cat=='cases' && stat=='rate' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"rate_confirmed"} />}
            {cat=='deaths' && stat=='rate' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"rate_death"} /> }
            {cat=='cases' && stat=='14dayrate' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"confirmed_last_14_per_100k"} />}
            {cat=='deaths' && stat=='14dayrate' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"deaths_last_14_per_100k"} />}
            {cat=='cases' && stat=='7dayrate' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"confirmed_last_7_per_100k"} />}
            {cat=='deaths' && stat=='7dayrate' && <StatecountyCovidAreaspline county={county} state={state} region={region} covidField={"deaths_last_7_per_100k"} />}
            <FigureCaption short_caption={'COVID reports over time.'} caption={'COVID reported cases and deaths over time. Data from COVID Tracking Project (state, region) and John Hopkins University (county).'} />
        </div>
    )
}